import { z } from 'zod';

import { AvailableLanguages } from 'common/hooks/useCurrentLanguage/types';
import { nonEmptyStringSchema } from 'common/zod/schemas';

import { parseAmount } from '../TransferDetails/utils';
import locales from './locales';

export const getInternationalTransferAmountAndCurrencyFormSchema = ({
  lang,
  validateBalance,
}: {
  lang: AvailableLanguages;
  validateBalance: () => boolean;
}) =>
  z.object({
    amount: nonEmptyStringSchema
      .refine((val) => {
        const amount = parseAmount(String(val), lang);
        return amount !== undefined && amount > 0;
      }, locales.invalidAmount)
      .refine(validateBalance, locales.amountOverBalance),
    currency: z.object({
      code: nonEmptyStringSchema,
      isoCountryCode: nonEmptyStringSchema,
      name: nonEmptyStringSchema,
      supportsDecimals: z.boolean(),
    }),
  });

export type InternationalTransferAmountAndCurrencyFormSchema = z.infer<
  ReturnType<typeof getInternationalTransferAmountAndCurrencyFormSchema>
>;
